module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/icons-b15db15f746f29ffa02638cb455b8ec0.woff2";